import { Progress as AntdProgress, ProgressProps } from 'antd';
import React from 'react';

/**
 * Adds an "indeterminate" state when percent is undefined.
 */
export function Progress(props: ProgressProps) {
  let className = props.className || '';
  if (props.percent === undefined) {
    // See adjustments.scss
    className = `${className} indeterminate`.trim();
  }
  // Note: key is here to prevent CSS transitions between determinate/indeterminate states.
  return (
    <AntdProgress status="active" showInfo={false} {...props} className={className} key={props.percent === undefined ? 'no-val' : 'val'} />
  );
}
